import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledEnrichmentHistoryWrapper = styled.div`
    position: relative;
    height: 643px;
`;

export const StyledModalBody = styled.div`
    flex-direction: column;
    display: flex;
    padding: 20px 29px 0 17px;
`;

export const HistoryTitle = styled.div`
    ${setFontVariant("h5")}
`;

export const StyledSearchContainer = styled.div`
    padding: 28px 10px 16px 0;
`;

export const StyledEnrichedContent = styled.div`
    overflow-y: scroll;
    height: 435px;
`;

export const StyledNoResultsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    & div {
        padding-left: 5px;
        ${setFontVariant("subtitle1", colorsPalettes.carbon[250])};
    }
`;

export const HistoryFooter = styled.div`
    display: flex;
    padding-right: 29px;
    height: 67px;
    align-items: center;
    flex-direction: row-reverse;
    border-top: 1px solid ${colorsPalettes.carbon[100]};

    & .Button {
        display: flex;
        align-items: center;
        justify-content: center;
        ${setFontVariant("button", colorsPalettes.blue[400])}
    }
`;
